import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getAffiliateOffers = async (panelListId: number, countryCode: string) => {
  return secureGet("/api/affiliate/offers", { panelListId, countryCode });
};

export const clickAffiliateOffer = async (offerId: number, panelListId: number, ipAddress: string) => {
  return securePost("/api/affiliate/click", { offerId, panelListId, ipAddress });
};